class Defaults {
    constructor() {

        this.init();
    }

    init() {
        var ua = window.navigator.userAgent;
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

        if (iOSSafari == true) {
            document.body.classList.add('is--iossafari');
        } else if (iOS == true) {
            document.body.classList.add('is--ios');
        } else if (webkit == true) {
            document.body.classList.add('is--webkit');
        }

        /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
        var prevScrollpos = window.pageYOffset;
        window.onscroll = function() {
            var currentScrollPos = window.pageYOffset;

            if (prevScrollpos > currentScrollPos) {
                document.body.classList.remove('hide--header');
            } else if (currentScrollPos > 100) {
                document.body.classList.add('hide--header');
            }
            prevScrollpos = currentScrollPos;
        }

        // ADD ASTRIXES TO REQUIRED FIELDS
        var requiredFields = document.querySelectorAll('input[required=required], textarea[required=required], ul[aria-required=true]');
        requiredFields.forEach(function(element) {
            var field = element.closest('.field');
            var label = field.querySelector('label');
            label.innerHTML += '<span class="required"> *</span>';
        });
    }
}

export default Defaults;